import * as React from 'react';
type Props = {
  className?: string;
};
export function Oven({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Oven"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.2972 3.75H3.31936C2.86877 3.75 2.5 4.09336 2.5 4.51235V19.3848V26.5373V32.6237H38.1165V26.5373V19.3848V4.51235C38.1165 4.09336 37.7478 3.75 37.2972 3.75Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.969 29.8332H7.74495C6.68103 29.8332 5.81055 28.5864 5.81055 27.0626V15.5495C5.81055 14.0256 6.68103 12.7788 7.74495 12.7788H32.969C34.0329 12.7788 34.9034 14.0256 34.9034 15.5495V27.0626C34.9034 28.5864 34.0329 29.8332 32.969 29.8332Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5385 24.08V26.9633C14.5385 27.2026 14.772 27.3983 15.0568 27.3983H25.0451C25.3305 27.3983 25.5635 27.2026 25.5635 26.9633V24.08H14.5385Z"
        stroke="currentColor"
      />
      <path d="M13.4359 24.08H26.6659" stroke="currentColor" />
      <path d="M25.6525 25.8578H34.7675" stroke="currentColor" />
      <path d="M5.849 25.8578H14.5951" stroke="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.7482 32.6284C30.6532 32.9339 30.5949 33.2737 30.5949 33.6389C30.5949 35.0129 30.4574 35.7487 31.9832 35.7487C33.4948 35.7487 33.3672 34.9515 33.3672 33.6389C33.3672 33.2737 33.3088 32.9339 33.2139 32.6284H30.7482Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44177 32.6498C7.34685 32.9554 7.28848 33.2952 7.28848 33.6604C7.28848 35.0344 7.15101 35.7702 8.67681 35.7702C10.1884 35.7702 10.0608 34.973 10.0608 33.6604C10.0608 33.2952 10.0024 32.9554 9.90749 32.6498H7.44177Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.52929 8.3935C9.52929 9.2961 8.85421 10.0274 8.02105 10.0274C7.18789 10.0274 6.51282 9.2961 6.51282 8.3935C6.51282 7.49091 7.18789 6.75958 8.02105 6.75958C8.85421 6.75958 9.52929 7.49091 9.52929 8.3935Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7342 8.3935C16.7342 9.2961 16.0592 10.0274 15.226 10.0274C14.3928 10.0274 13.7178 9.2961 13.7178 8.3935C13.7178 7.49091 14.3928 6.75958 15.226 6.75958C16.0592 6.75958 16.7342 7.49091 16.7342 8.3935Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5869 8.3935C27.5869 9.2961 26.9118 10.0274 26.0787 10.0274C25.2455 10.0274 24.5704 9.2961 24.5704 8.3935C24.5704 7.49091 25.2455 6.75958 26.0787 6.75958C26.9118 6.75958 27.5869 7.49091 27.5869 8.3935Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.7919 8.3935C34.7919 9.2961 34.1168 10.0274 33.2836 10.0274C32.4505 10.0274 31.7754 9.2961 31.7754 8.3935C31.7754 7.49091 32.4505 6.75958 33.2836 6.75958C34.1168 6.75958 34.7919 7.49091 34.7919 8.3935Z"
        stroke="currentColor"
      />
      <path
        d="M17.1674 18.75C17.3102 18.8261 17.5292 18.8622 17.7789 19.3188C17.9632 19.6513 17.9445 19.9224 17.8377 20.2068C17.6694 20.6594 17.4197 20.7022 17.2688 21.1107C17.1086 21.5487 17.2768 21.9346 17.7095 22.2644"
        stroke="currentColor"
      />
      <path
        d="M19.9462 18.75C20.089 18.8261 20.308 18.8622 20.5577 19.3188C20.742 19.6513 20.7233 19.9224 20.6165 20.2068C20.4482 20.6594 20.1985 20.7022 20.0476 21.1107C19.8874 21.5487 20.0557 21.9346 20.4883 22.2644"
        stroke="currentColor"
      />
      <path
        d="M22.725 18.75C22.8678 18.8261 23.0868 18.8622 23.3365 19.3188C23.5208 19.6513 23.5021 19.9224 23.3953 20.2068C23.227 20.6594 22.9773 20.7022 22.8265 21.1107C22.6662 21.5487 22.8345 21.9346 23.2671 22.2644"
        stroke="currentColor"
      />
      <path d="M17.5 14.8766L23.1427 14.9023" stroke="currentColor" />
    </svg>
  );
}
